import * as RCheckbox from "@radix-ui/react-checkbox"
import { CheckIcon } from "@radix-ui/react-icons"
import clsx from "clsx"
import { ComponentProps } from "react"
import { twMerge } from "tailwind-merge"
import { tv } from "tailwind-variants"

type Props = ComponentProps<typeof RCheckbox.Root> & {
  value?: string | number
  checked?: boolean
  onChange?: (value: boolean) => void
  disabled?: boolean
  size?: "small" | "large"
}

const createStyles = tv({
  slots: {
    root: "flex flex-none w-checkbox h-checkbox border-2 border-grey-mid text-grey-mid appearance-none items-center justify-center outline-none hover:bg-grey-mid hover:text-glass transition-colors duration-200 data-[state=checked]:bg-black data-[state=checked]:text-glass data-[state=checked]:border-black data-[state=checked]:hover:bg-grey-mid data-[state=checked]:hover:text-glass data-[state=checked]:hover:border-grey-mid data-[disabled]:bg-grey-light data-[disabled]:text-glass data-[disabled]:border-grey-light data-[state=checked]:data-[disabled]:bg-grey-light data-[state=checked]:data-[disabled]:text-glass data-[state=checked]:data-[disabled]:border-grey-light data-[state=checked]:data-[disabled]:hover:bg-grey-light data-[state=checked]:hover:data-[disabled]:text-glass data-[state=checked]:data-[disabled]:hover:border-grey-light error:border-error-dark error:text-error-dark",
    checkbox: "w-checkbox h-checkbox",
  },
  variants: {
    size: {
      small: {
        root: "w-[16px] h-[16px] border",
        checkbox: "w-[16px] h-[16px]",
      },
      large: {},
    },
  },
})

export function Checkbox(props: Props) {
  const { value, checked, onChange, disabled, className, ...additionalProps } = props
  const styles = createStyles({ size: props.size })

  return (
    <RCheckbox.Root className={twMerge(styles.root(), className)} {...additionalProps} value={value} checked={checked} onCheckedChange={onChange} disabled={disabled}>
      <RCheckbox.Indicator className="text-current transition-colors duration-200">
        <CheckIcon className={styles.checkbox()} />
      </RCheckbox.Indicator>
    </RCheckbox.Root>
  )
}
